import { ReactNode, RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import classNames from 'classnames'
import gsap from 'gsap'

import { useLenis } from '@/contexts/lenis'

type ImageParallaxProps = {
  fill?: boolean
  // eslint-disable-next-line no-unused-vars
  children: (ref: RefObject<HTMLImageElement>) => ReactNode
}

const ImageParallax = ({ children, fill = false }: ImageParallaxProps) => {
  const image = useRef<HTMLImageElement>(null)
  const { lenis } = useLenis()

  useGSAP(
    () => {
      if (!lenis || !image.current) return

      gsap.to(image.current, {
        scrollTrigger: {
          trigger: image.current,
          start: 'top 100%',
          end: 'bottom 0%',
          scrub: true,
          once: false
        },
        yPercent: -15,
        ease: 'none'
      })
    },
    { scope: image, dependencies: [lenis] }
  )

  return (
    <span
      className={classNames('overflow-hidden [&_img]:!h-[115%]', {
        'relative block': !fill,
        'absolute left-0 top-0 h-full w-full': fill
      })}
    >
      {children(image)}
    </span>
  )
}

export default ImageParallax
